import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { IndicateurServiceService } from '../indicateur/indicateur.component';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-planification',
  templateUrl: './planification.component.html',
  styleUrl: './planification.component.scss'
})
export class PlanificationComponent implements OnInit {
  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  paginatedProjets = [];
  items: any;
  planification: Planification = new Planification();
  planificationsList: any[] = [];
  isLoading: boolean = false;
  submitted: boolean = false;

  annees: number[] = [];

  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private indicateurService: IndicateurServiceService,
    private ngxService: NgxUiLoaderService
  ) {
    const currentYear = new Date().getFullYear();
    // Generate years from current year - 5 to current + 10 for planning
    // This allows planning for past years (missed entries) and future years
    for (let year = currentYear - 5; year <= currentYear + 10; year++) {
      this.annees.push(year);
    }
    // Sort years in descending order (most recent first)
    this.annees.sort((a, b) => b - a);
  }

  ngOnInit() {
    this.items = this.localstorage.getPlanification();
    console.log(this.items);
    
    
    if (this.items && this.items.reference) {
      this.planification.indicateur_id = this.items.reference;
     // this.fetchPlanifications();
    } else {
      // this.messageService.add({ 
      //   severity: 'warn', 
      //   summary: Constant.suiviTitle, 
      //   detail: "Aucune donnée d'indicateur trouvée" 
      // });
    }
  }

  // fetchPlanifications() {
  //   this.isLoading = true;
    
  //   this.paramservice.getCibleIndicateurs().subscribe(
  //     (response: any) => {
  //       this.isLoading = false;
        
  //       if (response && response.data) {
  //         // Filter planifications for this indicator
  //         this.planificationsList = response.data.filter(
  //           (p: any) => p.indicateur_id === this.items.reference || 
  //                       p.indicateur?.reference === this.items.reference
  //         );
          
  //         // Update pagination
  //         this.totalRecords = this.planificationsList.length;
  //         this.updatePaginatedProjets();
  //       }
  //     },
  //     (error) => {
  //       this.isLoading = false;
  //       console.error('Erreur lors de la récupération des planifications:', error);
  //       // this.messageService.add({ 
  //       //   severity: 'error', 
  //       //   summary: Constant.suiviTitle, 
  //       //   detail: 'Erreur lors de la récupération des planifications' 
  //       // });
  //     }
  //   );
  // }

  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.planificationsList.slice(start, end);
  }

  onPageChangeProjets(event: any) {
    this.firstProjets = event.first;
    this.rowsProjets = event.rows;
    this.updatePaginatedProjets();
  }

  savePlanification() {
    this.submitted = true;

    // Validation
    if (!this.planification.annee) {
      this.messageService.add({ 
        severity: 'info', 
        summary: Constant.suiviTitle, 
        detail: "Veuillez sélectionner l'année" 
      });
      return;
    }

    if (!this.planification.valeur_cible && this.planification.valeur_cible !== 0) {
      this.messageService.add({ 
        severity: 'info', 
        summary: Constant.suiviTitle, 
        detail: "Veuillez saisir la valeur cible" 
      });
      return;
    }

    // Check if target value is positive
    if (this.planification.valeur_cible < 0) {
      this.messageService.add({ 
        severity: 'warn', 
        summary: Constant.suiviTitle, 
        detail: "La valeur cible doit être positive" 
      });
      return;
    }

    // Check if a target already exists for this year
    const existingPlanification = this.planificationsList.find(
      p => p.annee === this.planification.annee
    );

    if (existingPlanification) {
      this.confirmationService.confirm({
        message: `Une cible existe déjà pour l'année ${this.planification.annee}. Voulez-vous la mettre à jour ?`,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        rejectButtonStyleClass: 'p-button-text',
        acceptLabel: 'Oui',
        rejectLabel: 'Non',
        accept: () => {
          this.updatePlanification(existingPlanification);
        },
        reject: () => {
          // Do nothing
        }
      });
      return;
    }

    this.createPlanification();
  }

  createPlanification() {
    this.ngxService.start();

    this.paramservice.savePlanificationToIndicateur(this.planification).subscribe(
      (response: any) => {
        this.ngxService.stop();

        if (response.status === 'error') {
          this.messageService.add({ 
            severity: 'error', 
            summary: Constant.suiviTitle, 
            detail: response.message || 'Erreur lors de la sauvegarde' 
          });
          this.modalService.dismissAll();
          return;
        }

        this.messageService.add({ 
          severity: 'success', 
          summary: Constant.suiviTitle, 
          detail: response.message || 'Planification créée avec succès' 
        });

        // Notify parent component and refresh
        this.indicateurService.notifyProgrammeCreated();
      //  this.fetchPlanifications();
        this.resetForm();
      },
      (error) => {
        this.ngxService.stop();
        console.error('Erreur lors de la création de la planification:', error);
        this.messageService.add({ 
          severity: 'error', 
          summary: Constant.suiviTitle, 
          detail: error.message || 'Une erreur est survenue lors de la sauvegarde' 
        });
      }
    );
  }

  updatePlanification(existingPlanification: any) {
    this.ngxService.start();

    const updateData = {
      id: existingPlanification.id || existingPlanification.valeur_cible_id,
      valeur_cible: this.planification.valeur_cible,
      annee: this.planification.annee,
      indicateur_id: this.planification.indicateur_id
    };

    this.paramservice.updateCible(updateData.id, updateData).subscribe(
      (response: any) => {
        this.ngxService.stop();

        if (response.status === 'error') {
          this.messageService.add({ 
            severity: 'error', 
            summary: Constant.suiviTitle, 
            detail: response.message || 'Erreur lors de la mise à jour' 
          });
          return;
        }

        this.messageService.add({ 
          severity: 'success', 
          summary: Constant.suiviTitle, 
          detail: response.message || 'Planification mise à jour avec succès' 
        });

      //  this.fetchPlanifications();
        this.resetForm();
      },
      (error) => {
        this.ngxService.stop();
        console.error('Erreur lors de la mise à jour de la planification:', error);
        this.messageService.add({ 
          severity: 'error', 
          summary: Constant.suiviTitle, 
          detail: error.message || 'Une erreur est survenue lors de la mise à jour' 
        });
      }
    );
  }

  deletePlanification(planification: any) {
    this.confirmationService.confirm({
      message: `Êtes-vous sûr de vouloir supprimer la cible pour l'année ${planification.annee} ?`,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();

        const id = planification.id || planification.valeur_cible_id;
        
        this.paramservice.deleteCibleIndicateur(id).subscribe(
          (response: any) => {
            this.ngxService.stop();

            if (response.status === 'error') {
              this.messageService.add({ 
                severity: 'error', 
                summary: Constant.suiviTitle, 
                detail: response.message || 'Erreur lors de la suppression' 
              });
              return;
            }

            this.messageService.add({ 
              severity: 'success', 
              summary: Constant.suiviTitle, 
              detail: response.message || 'Planification supprimée avec succès' 
            });

           // this.fetchPlanifications();
          },
          (error) => {
            this.ngxService.stop();
            console.error('Erreur lors de la suppression de la planification:', error);
            this.messageService.add({ 
              severity: 'error', 
              summary: Constant.suiviTitle, 
              detail: error.message || 'Une erreur est survenue lors de la suppression' 
            });
          }
        );
      },
      reject: () => {
        // Do nothing
      }
    });
  }

  resetForm() {
    this.planification = new Planification();
    this.planification.indicateur_id = this.items?.reference;
    this.submitted = false;
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  // Helper method to check if year has target
  hasTargetForYear(year: number): boolean {
    return this.planificationsList.some(p => p.annee === year);
  }

  // Get target for specific year
  getTargetForYear(year: number): any {
    return this.planificationsList.find(p => p.annee === year);
  }

  // Calculate execution rate
  getTauxExecution(plan: any): number {
    if (!plan.valeur_cible || plan.valeur_cible === 0) {
      return 0;
    }
    const realisee = plan.valeur_realisee || 0;
    return (realisee / plan.valeur_cible) * 100;
  }

  // Edit existing planification
  editPlanification(plan: any): void {
    this.planification.annee = plan.annee;
    this.planification.valeur_cible = plan.valeur_cible;
    this.planification.indicateur_id = plan.indicateur_id || this.items?.reference;
    this.submitted = false;
  }
}

export class Planification {
  annee: any;
  valeur_cible: any;
  indicateur_id: any;

  constructor() {
    this.annee = null;
    this.valeur_cible = null;
    this.indicateur_id = null;
  }
}
